import { render, staticRenderFns } from "./modals.vue?vue&type=template&id=3b86d174&scoped=true"
import script from "./modals.vue?vue&type=script&lang=js"
export * from "./modals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86d174",
  null
  
)

export default component.exports